module.exports = __webpack_public_path__ + "static/img/logo5.71c5223.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo5.png
// module id = zkuu
// module chunks = 1